export enum PaySoftBankList {
    ABSA = '632005',
    FNB = '250655',
    StandardBank = '051001',
    Nedbank = '198765',
    Capitec = '470010',
}
